module.exports = __webpack_public_path__ + "static/media/aiSparkleIcon.b453fc98.svg";